<!-- @veltra/icons generated sha256:45c65efff6d001b0 gen:8 source:src/svg/normal/filter.svg -->
<script setup lang="ts">
defineOptions({ name: 'UFilter' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M2 3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1.22c0 .355-.194.68-.5.86L9.997 7.14a.5.5 0 0 0-.246.428v5.429A1 1 0 0 1 8.752 14H7.248a1 1 0 0 1-.998-1.002V7.569a.5.5 0 0 0-.246-.428L2.5 5.08c-.306-.18-.5-.505-.5-.86zm11 0H3v1.214l4.004 2.355a.49.49 0 0 1 .246.426V13h1.5V6.995a.49.49 0 0 1 .246-.426L13 4.214z"
    />
  </svg>
</template>
